<template>
    <div>
      <!-- <span style v-for="(locale, index) in locales" :key="locale" @click="switchLocale(index)">{{locale}} </span> -->

      <div class="ul-lenguaje">
        <span class="span-locale es" ref="es" @click="switchLocale('es')">ESP </span>
        <span>| </span>
        <span class="span-locale en" ref="en" @click="switchLocale('en')">ENG</span>
      </div>
    </div>
</template>


<style>

.ul-lenguaje{
    font-family: 'Gotham Book Regular';
    letter-spacing: 2.46px;
    font-size: 32px !important;
    line-height: 34px !important;
    position: absolute;
    top: 880px;
    left: 7%;
    list-style: none !important;
    display: inline !important;
    transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
    z-index: 3;
    cursor:pointer;
    color: #ffffff !important
}

.active-locale{
  /* color:red; */
  font-family: 'Gotham Bold Regular';
  font-weight: bold;
}

@media screen and (max-width: 960px) and (min-width: 100px){

  .ul-lenguaje{
    font-family: 'Gotham Book Regular';
    letter-spacing: 2.46px;
    font-size: 15px !important;
    line-height: 17px !important;
    position: absolute;
    top: 700px !important;
    left: 7%;
    list-style: none !important;
    display: inline !important;
    transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
    z-index: 3;
    cursor: pointer;
    margin-left: 5%;
  }
}

@media screen and (max-width: 1800px) and (min-width: 961px){

  .ul-lenguaje{
    font-family: 'Gotham Book Regular';
    letter-spacing: 2.46px;
    font-size: 20px !important;
    line-height: 22px !important;
    position: absolute;
    top: 610px !important;
    left: 7%;
    list-style: none !important;
    display: inline !important;
    transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
    z-index: 3;
    cursor: pointer;
  }

}

</style>

<script>
export default {
  name: "LanguageSwitcher",
  data(){
    return {
      localLan: 'es',
      locales: {
        "es": "ESP",
        "en": "ENG"
      }
    }
  },
  mounted(){
    if (typeof(Storage) !== "undefined") {
      // console.log("LocalStorage disponible");
    
      if(localStorage.getItem("lang") === null){
        this.$i18n.locale = this.localLan;
      }else{
        this.$i18n.locale = localStorage.getItem("lang");
      }
    } else {
      // console.log("LocalStorage no soportado en este navegador");
    }

    let select=document.getElementsByClassName(''+this.$i18n.locale);
    for (const sel of select) {
          sel.classList.add('active-locale');
    }
  },
  methods: {

    switchLocale(locale){
      if(this.$i18n.locale !== locale){
        this.$i18n.locale = locale;

        localStorage.setItem("lang",this.$i18n.locale);

        let elem=document.getElementsByClassName('span-locale');
        for (const ele of elem) {
          ele.classList.remove('active-locale');
        }

        let select=document.getElementsByClassName(''+locale);
        for (const sel of select) {
          sel.classList.add('active-locale');
        }
      }
    }
  }
};
</script>
